import { useEffect, useState } from 'react';
import { myCompanyService } from '../../services/companies/myCompanyService.js';

export const useCompanyName = () => {
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    let cancelled = false;

    const loadName = async () => {
      try {
        const { company } = await myCompanyService.getMyCompany();
        if (cancelled) return;

        setCompanyName(company.name || '');
      } catch (error) {
        console.error('Error loading company name:', error);
      }
    };

    loadName();

    return () => {
      cancelled = true;
    };
  }, []);

  return companyName;
};
